import api from "./index";

export interface ProgramTermListParams {
  title?: string;
  order?: "ASC" | "DESC";
  offset?: number;
  limit?: number;
  options?: any;
}

export default (params: ProgramTermListParams, options?: any) => {
  return api.ProfessionalProgramTaxonomyApi.list(
    params.title,
    params.order,
    params.offset,
    params.limit,
    options
  );
};
